/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import bind from 'lodash/bind';

import { queryAncestor } from '../../01-helpers/utilities/dom';
import Calendar from '../../04-components/calendar/calendar';




/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */
const
	attributeName = {
		timestamp: 'data-timestamp'
	},

	selector = {
		selectableDay: `[${ attributeName. timestamp }]`
	};



/* ========================================================================== *\
	EVENT HANDLING
\* ========================================================================== */
/**
 * @this DatePicker
 */
function bindEvents() {
	this.baseElement.addEventListener('click', bind(onClick, this));
}

/**
 *
 * @param {Event} event
 *
 * @this DatePicker
 */
function onClick(event) {
	const
		dayElement = queryAncestor(event.target, selector.selectableDay, this.baseElement);
	if (dayElement === null || !dayElement.classList.contains('is-available')) {
		return;
	}

	const
		date = new Date(parseInt(dayElement.getAttribute(attributeName.timestamp), 10));
	this._onDateSelected(date);
}



/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */
export default class DatePicker extends Calendar {
	/* ====================================================================== *\
		CONSTRUCTOR
	\* ====================================================================== */
	constructor(baseElement, options) {
		super(baseElement, options);

		bindEvents.call(this);
	}



	/* ====================================================================== *\
		PROTECTED METHODS
	\* ====================================================================== */
	/**
	 *
	 * @param {Date} date
	 *
	 * @protected
	 */
	_onDateSelected(date) {
		//
	}

	/**
	 *
	 * @param {Date} start
	 * @param {Date} end
	 *
	 * @protected
	 */
	_updateSelectedRange(start, end) {
		this.selection.updateRange(start, end);
	}
}

